define('glu/grid/genericLayout',['require','../layout','hbs!./genericLayout.hbs'],function(require) {
    'use strict';

    var Layout = require('../layout'),
        tpl = require('hbs!./genericLayout.hbs');

    return Layout.extend({
        template: tpl,

        collectionEvents: {
            'grid:filter:change': 'showLoader',
            'grid:filters:clear': 'showLoader'
        },

        initialize: function() {
            this.listenTo(this, {
                'grid:contentRendered': this.hideLoader,
                'grid:content:empty': this.hideLoader
            });
        },

        setHeader: function(header) {
            this.headerView = header;
        },

        setFooter: function(footer) {
            this.footerView = footer;
        },

        setContent: function(view) {
            this.contentView = view;
        },

        setManageColumns: function(view) {
            this.manageColumnsView = view;
        },

        onRender: function() {
            if (this.headerView) {
                this.header.show(this.headerView);
            }

            if (this.manageColumnsView) {
                this.manageColumns.show(this.manageColumnsView);
            }

            if (this.contentView) {
                this.content.show(this.contentView);
            }

            if (this.footerView) {
                this.footer.show(this.footerView);
            }
        },

        showLoader: function() {
            if (this.options.showLoaderOnFilter) {
                this.$('.loader').removeClass('hidden');
                this.$('.content').addClass('loading');
            }
        },

        hideLoader: function() {
            if (this.options.showLoaderOnFilter) {
                this.$('.loader').addClass('hidden');
                this.$('.content').removeClass('loading');
            }
        }
    });
});

